import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import useProfile from '../../hooks/useProfile'
import { useNavigate } from 'react-router-dom'

import ProfileTabs from './ProfileTabs'
import React, { useState } from 'react'
import ProfileContent from './ProfileContent'
import EditGeneralDataModal from './components/modals/EditGeneralDataModal'
import ChangePasswordModal from './components/modals/ChangePasswordModal'

const Profile = () => {
  const {
    profileData,
    paymentData,
    handleUpdateData,
    handleInput,
    tab,
    handleChange,
    remainedUniversities,
    isGeneralModalOpened,
    setIsGeneralModalOpened,
    profileDataForModal,
    isSaveButtonDisabled,
    handleUniversitiesChange,
    isChangePasswordModalOpened,
    setIsChangePasswordModalOpened,
    error,
  } = useProfile()
  const navigate = useNavigate()
  const achievements = profileData.achievements
  const payments = paymentData.payments
  const paymentDetails = paymentData.cards
  return (
    <DashboardLayout className="absolute">
      <div className="flex max-w-[800px] ml-auto mr-auto transition-all duration-700 ease-in-out">
        <div className="ml-auto mr-auto relative w-full ">
          <ProfileTabs tab={tab} handleChange={handleChange} />
          <ProfileContent
            payments={payments}
            setIsChangePasswordModalOpen={setIsChangePasswordModalOpened}
            achievements={achievements}
            setIsGeneralModalOpen={setIsGeneralModalOpened}
            profileData={profileData}
            tab={tab}
          />
        </div>
      </div>
      <EditGeneralDataModal
        error={error}
        handleUniversitiesChange={handleUniversitiesChange}
        isSaveButtonDisabled={isSaveButtonDisabled}
        handleUpdateData={handleUpdateData}
        setIsGeneralModalOpen={setIsGeneralModalOpened}
        handleInput={handleInput}
        remainedUniversities={remainedUniversities}
        isOpen={isGeneralModalOpened}
        profileDataForModal={profileDataForModal}
      />
      <ChangePasswordModal
        isChangePasswordModalOpen={isChangePasswordModalOpened}
        setIsChangePasswordModalOpen={setIsChangePasswordModalOpened}
      />
    </DashboardLayout>
  )
}

export default Profile
